import React, { type Dispatch, type SetStateAction, useEffect } from 'react';

import { Button, Row, Col, Typography } from 'darrius';

import styles from './PhoneInUse.module.scss';

interface IPhoneInUseProps {
  phone: string;
  setPhoneInUse: Dispatch<SetStateAction<boolean>>;
}

export const PhoneInUse = ({ phone, setPhoneInUse }: IPhoneInUseProps) => {
  useEffect(() => {
    function triggerEvent() {
      window.tagManager.custom({
        event: 'selfDescribingEvent',
        schema: 'iglu:br.com.getninjas/pro_sign_up/jsonschema/1-0-1',
        data: {
          step: 'alredy_register',
          action: 'click',
          country: 'pt-BR',
          state: 'Telefone em uso',
          token: '',
        },
      });
    }

    triggerEvent();
  });

  return (
    <>
      <Row
        className={`phone-in-use center-sm space-top ${styles['phone-in-use']}`}
      >
        <Col className="col-sm-">
          <img
            src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/rounded-alert.svg`}
            alt="Seta para volta ao passo anterior"
          />
        </Col>
      </Row>

      <Row className={`${styles['center-sm']} center-sm`}>
        <Col>
          <Typography.Title as="h3" size="3xl" className={styles['title']}>
            Este número de celular já possui um cadastro
          </Typography.Title>

          <Typography.Text className={styles['text']}>
            Deseja entrar com o número abaixo ou cadastrar-se com outro celular?
          </Typography.Text>

          <Typography.Subtitle
            size="m"
            className={`${styles.subtitle} space-bottom`}
          >
            {phone}
          </Typography.Subtitle>
        </Col>
      </Row>

      <Row className="center-sm">
        <Col
          className={`phone-in-use__buttons col-sm-11 col-md-6 ${styles['phone-in-use__buttons']}`}
        >
          <Button.Link
            type="button"
            variation="primary"
            href="/sucesso?deep_link=https://www.getninjas.com.br/a/h0GdDTRO9v"
            fullWidth
          >
            Baixar o app
          </Button.Link>

          <Button.Root
            type="button"
            variation="secondary"
            onClick={() => setPhoneInUse(false)}
            fullWidth
          >
            Editar número
          </Button.Root>
        </Col>
      </Row>
    </>
  );
};
